import * as React from "react";
import { ThemeProvider } from "styled-components";
import Body from "@/components/core-blocks/Body";
import CookieConsent from "@/components/core-blocks/CookieConsent";
import Footer from "@/components/core-blocks/Footer";
import Header from "@/components/core-blocks/Header";
import Main from "@/components/core-blocks/Main";
import Seo from "@/components/core-blocks/Seo";
import { FundInfo, SEOProps } from "@/src/types";
import Flexible, { IFlexible } from "@/src/components/core-blocks/Flexible";
import GlobalStyle from "@/styles/global";
import defaultTheme from "@/styles/themes/default.theme";
import GtmContainer from "@/components/core-blocks/GtmContainer";
import TextHero from "@/components/layout-blocks/TextHero";
import Breadcrumbs from "@/components/layout-blocks/Breadcrumbs";
import S from "./fund.styled";
import { gatsbyImageHelper } from "@/src/helpers";
import FileIcon from "@/assets/file.svg";
import GatsbyLink from "@/components/core-blocks/GatsbyLink";
import { CookieBannerProvider } from "@/src/context/CookieBannerContext";
import FundSingle from "@/components/FundSingle";
import FundManagers from "@/components/FundSingle/sub-components/FundManagers";
import {FundProvider} from "@/components/FundSingle/FundProvider";

export type IPageTemplate = {
  pageContext: {
    title: string;
    fundInfo: FundInfo;
    flexible: IFlexible;
    seo: SEOProps;
  };
};

const PageTemplate: React.FC<IPageTemplate> = ({
  pageContext: {
    title,
    fundInfo: {
      image,
      ingress,
      trustees,
      factSheets,
      sustainabilityLink,
      placementOrientation,
      text,
      morningstarId,
      externalLinkMorningstarMethod
    },
    flexible: { components },
    seo: { breadcrumbs },
  },
}) => {

  return (
    <CookieBannerProvider>
    <ThemeProvider theme={defaultTheme}>
      <FundProvider morningstarId={morningstarId} externalLinkMorningstarMethod={externalLinkMorningstarMethod}>
      <GlobalStyle />
      <Body>
        <Header fixed={true} />
        <Main>
          <TextHero image={image} title={title} text={ingress} />
          <Breadcrumbs breadcrumbs={breadcrumbs} width="100%" />
          <FundSingle></FundSingle>
          <FundManagers
            trustees={trustees}
            factSheets={factSheets}
            sustainabilityLink={sustainabilityLink}
            placementOrientation={placementOrientation}
            text={text}
          ></FundManagers>
          <Flexible components={components} breadcrumbs={breadcrumbs} />
          <Footer />
          <CookieConsent />
        </Main>
      </Body>
      </FundProvider>
    </ThemeProvider>
    </CookieBannerProvider>
  );
};

export default PageTemplate;

export function Head({ pageContext: { seo } }: IPageTemplate) {
  return (
    <>
      <GtmContainer />
      <html lang="sv" />
      <Seo {...seo} lang="sv" />
    </>
  );
}
